import { render, staticRenderFns } from "./EventsDashboard.vue?vue&type=template&id=7864ff26"
import script from "./EventsDashboard.vue?vue&type=script&lang=js"
export * from "./EventsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports